<template>
  <div>
    <el-dialog :visible.sync="visible" width="500px" :close-on-click-modal="false" :show-close="false" append-to-body>
      <i class="el-icon-close closebtn" @click="visible = false"></i>
      <div class="panel-main">
        <h2>{{ $t("礼品码兑换") }}</h2>
        <div class="r">
          <el-input type="primary" v-model="code" :placeholder="$t('请输入礼品码')"></el-input>
        </div>
        <div class="p">
          <ul>
            <li>{{ $t("一个礼品码限使用一次，可以兑换Dreamrail火车券") }}</li>
            <li v-if="$i18n.locale == 'ZH'">兑换完成后您可以前往“用户账户”-“<a href="https://dreamrail.cn/wallet?tab=2" target="_blank">我的火车券</a>”中查看</li>
            <li v-if="$i18n.locale == 'EN'">After redemption, you can check the RailVoucher in 'User Account'-<a href="https://dreamrail.cn/wallet?tab=2" target="_blank">'RailVoucher'</a></li>
            <li>{{ $t("在您购买实体商品时可以获得一个礼品码，如无法使用请联系客服") }}</li>
            <li>{{ $t("部分活动会释出礼品码，请随时关注Dreamrail社交媒体账号活动信息") }}</li>
          </ul>
        </div>
      </div>
      <div class="text-center footer" slot="footer">
        <el-button type="primary" round @click="confirm">{{ $t("立即兑换") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      data: {},
      isPhone: false,
      code: "",
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        console.log(val);
      }
    },
  },
  mounted() {},
  methods: {
    //打开窗口
    openDialog(data) {
      console.log(data);
      this.data = data;
      this.visible = true;
      this.isPhone = this.$method.isMobile();
    },
    save() {
      this.visible = false;
      this.downloadPoster();
    },
    confirm() {
      if (!this.code) {
        this.$method.message(this.$t("请输入礼品码"), "error");
        return;
      }
      this.$method.showLoading();
      this.$method.invoke("useGiftCode", { code: this.code }).then((res) => {
        this.$method.hideLoading();
        if (res.code === 0) {
          window.$VUE.$message({
            dangerouslyUseHTMLString: true,
            message: `${this.$t("礼品码兑换成功！")}<a href="/wallet?tab=2" target="_blank">${this.$t("立即查看我的火车券")}</a>`,
            customClass: `dreamrail-message dreamrail-message-success`,
            iconClass: "dreamrail-message-icon",
          });
          this.visible = false;
        } else {
          this.$method.message(res.error.message, "error");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.closebtn {
  position: absolute;
  right: 20px;
  top: -10px;
  cursor: pointer;
  z-index: 10;
}
.panel-main {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h2 {
    font-weight: bold;
    font-size: 24px;
    color: #141414;
    line-height: 36px;
    text-align: center;
    margin: 30px 0 0 0;
  }
  .r {
    margin-top: 20px;
  }
  .p {
    margin-top: 40px;
    color: #999;
  }
}
</style>
